import ColorPickerPopup from './ColorPickerPopup'

export default ColorPickerPopup;
